module.exports = __webpack_public_path__ + "img/2023-06_service-to-the-state.eba1c9aa.png";